import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import React, { JSX, useState } from "react";
import { Link } from "react-router-dom";
import RSVPComponent from "../rsvp/rsvp";
import { useAuth } from "../../contexts/AuthContext";
import styles from "./navigation.module.css";

const renderNavItems: (onClick?: () => void, isAdmin?: boolean) => JSX.Element = (onClick, isAdmin = false) => {
  return (
    <>
      <Link className={styles.navItem} to="/" onClick={onClick}>Details</Link>
      <Link className={styles.navItem} to="/accommodation" onClick={onClick}>Accommodation</Link>
      <Link className={styles.navItem} to="/faq" onClick={onClick}>FAQ</Link>
      <Link className={styles.navItem} to="/registry" onClick={onClick}>Registry</Link>
      <Link className={styles.navItem} to="/photos" onClick={onClick}>Photos</Link>
      <RSVPComponent showInline={true} linkStyle={styles.navItem}/>
      {isAdmin && <Link className={styles.navItem} to="/admin" onClick={onClick}>Admin</Link>}
    </>
  );
};

const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAdmin } = useAuth();

  const toggleMenu = () => setMobileMenuOpen(!isMobileMenuOpen);

  return (
    <>
      <nav className={styles.desktopNav}>
        {renderNavItems(undefined, isAdmin)}
      </nav>
      <div className={styles.mobileNav}>
        {/* ToDo: convert to material icons. */}
        { !isMobileMenuOpen && <button className={styles.hamburgerIcon} onClick={toggleMenu}>
          <MenuIcon />
        </button> }
        { isMobileMenuOpen && <button className={styles.hamburgerIcon} onClick={toggleMenu}>
          <CloseIcon />
        </button> }
        { isMobileMenuOpen && <nav className={styles.mobileMenu}>{renderNavItems(toggleMenu, isAdmin)}</nav> }
      </div>
    </>
  );
};

export default Navigation;
